import { h, Fragment } from "preact";
import { useState, useEffect, useContext } from "preact/hooks";

import {
	Dialog,
	DialogTitle,
	Grid,
	Typography,
} from "@mui/material";

import MasterWeekViewPublic from "../DealMeetings/MasterWeekViewPublic";

export default function SlotsWhenConnectedDialog(props) {

	const handleClose = () => {
		props.onClose();
	};


	return (
		<Dialog onClose={handleClose} aria-labelledby="slots-dialog-title" open={props.state.opened}>
			<DialogTitle id="slots-dialog-title">
				<Typography variant="h5" style="">
					Les plages disponibles de rendez-vous</Typography>
			</DialogTitle>

			{/* {props.state.params.slots && props.state.params.slots.length === 0 && (
				<div style="height: 500px; width: 500px;">
					<Typography variant="h6" style="margin: 10px;">
						Oups, il n'y a pas de plages disponibles pour le moment, mais nous avons prévenu l'ambassadeur, il va vous recontacter
					</Typography>
					<div style="margin: 0 auto; height: 300px; width: 300px; background-size: contain; background-repeat: no-repeat; background-image: url('/images/sorry.png')" />
				</div>
			)} */}

			<Grid container>
				<Grid item xs={12}>
					<MasterWeekViewPublic
						state={{ ...props.state, deal_uid: props.state.params.id, actualDeal: props.state.params.actualDeal }}
						setUpperState={props.state.params.setState}
						handleClose={handleClose} />
				</Grid>
			</Grid>

		</Dialog>
	);
}
